import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brand-brown text-brand-cream mt-auto">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About Section */}
          <div>
            <h3 className="text-brand-cream font-display font-bold text-xl mb-4">Ilê Asé Sòpònnón</h3>
            <p className="text-sm leading-relaxed text-brand-beige">
              Comprometidos com a transparência e o bem-estar de nossa comunidade.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-brand-cream font-display font-bold text-xl mb-4">Links Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-brand-beige hover:text-brand-gold transition-colors">
                  Início
                </Link>
              </li>
              <li>
                <Link to="/transparencia" className="text-sm text-brand-beige hover:text-brand-gold transition-colors">
                  Portal de Transparência
                </Link>
              </li>
              <li>
                <Link to="/sobre" className="text-sm text-brand-beige hover:text-brand-gold transition-colors">
                  Sobre Nós
                </Link>
              </li>
              <li>
                <Link to="/associado/login" className="text-sm text-brand-beige hover:text-brand-gold transition-colors">
                  Área do Associado
                </Link>
              </li>
              <li>
                <Link to="/login" className="text-sm text-brand-beige hover:text-brand-gold transition-colors">
                  Área Administrativa
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-brand-cream font-display font-bold text-xl mb-4">Contato</h3>
            <ul className="space-y-2 text-sm text-brand-beige">
              <li>Email: contato@ileasesoponon.org.br</li>
              <li>Telefone: (11) 1234-5678</li>
              <li>Endereço: Rua Exemplo, 123 - São Paulo, SP</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-brand-gold/30 mt-8 pt-8 text-center text-sm">
          <p className="text-brand-beige">&copy; {currentYear} Ilê Asé Sòpònnón. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

